module.exports = __webpack_public_path__ + "static/media/mongodb.7247ed43.png";